import gsap from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";
import ScrollTrigger from "gsap/ScrollTrigger";

gsap.registerPlugin(MotionPathPlugin);
gsap.registerPlugin(ScrollTrigger);

export function initFadeIn() {
  const elements = document.querySelectorAll(".anim-fade-in");

  const observerOptions = {
    root: null, // Use the viewport as the container
    rootMargin: "0px",
    threshold: 0.15, // Trigger when 10% of the element is visible
  };

  const observerCallback = (entries, observer) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        gsap.to(entry.target, { opacity: 1, duration: 0.8 });
        observer.unobserve(entry.target); // Stop observing once the animation is done
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  elements.forEach((element) => {
    observer.observe(element);
  });

  console.log("Fade in animation initialized");
}

export function initParallax() {
  document.querySelectorAll("[parallax-hero-img]").forEach((section) => {
    gsap.to(section, {
      yPercent: -20,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: section,
        start: "bottom bottom",
        end: "bottom top",
        scrub: true,
        immediateRender: false,
      },
    });
  });

  document.querySelectorAll("[parallax-20]").forEach((section) => {
    gsap.to(section, {
      yPercent: -20,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  });

  document.querySelectorAll("[parallax-30]").forEach((section) => {
    gsap.to(section, {
      yPercent: -30,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
        immediateRender: false,
      },
    });
  });

  document.querySelectorAll("[parallax-40]").forEach((section) => {
    gsap.to(section, {
      yPercent: -40,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  });

  document.querySelectorAll("[parallax-20-down]").forEach((section) => {
    gsap.to(section, {
      yPercent: 20,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  });

  document.querySelectorAll("[parallax-30-down]").forEach((section) => {
    gsap.to(section, {
      yPercent: 30,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  });

  document.querySelectorAll("[parallax-40-down]").forEach((section) => {
    gsap.to(section, {
      yPercent: 40,
      ease: "power1.inOut",
      scrollTrigger: {
        trigger: section,
        start: "top bottom",
        end: "bottom top",
        scrub: true,
      },
    });
  });
}
